import { render } from "./TabAppointment.vue?vue&type=template&id=33e55ff8"
import script from "./TabAppointment.vue?vue&type=script&lang=js"
export * from "./TabAppointment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__